module.exports = __webpack_public_path__ + "static/media/status1.41d476fc.png";